import { useEffect, useState } from 'react';

// Personal preference on this device; never changes another staff member's UI.
export const useDutiVisibility = (userId) => {
  const key = `dutilyne_hide_assistant_${userId}`;
  const read = () => localStorage.getItem(key) !== '1';
  const [visible, setVisible] = useState(read);
  useEffect(() => {
    setVisible(localStorage.getItem(key) !== '1');
    const sync = event => { if (event.key === key) setVisible(event.newValue !== '1'); };
    window.addEventListener('storage', sync);
    return () => window.removeEventListener('storage', sync);
  }, [key]);
  const change = value => {
    localStorage.setItem(key, value ? '0' : '1');
    setVisible(value);
  };
  return [visible, change];
};